<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-1b19600 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1b19600" data-element_type="section" data-e-type="section">
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-52cc789" data-id="52cc789" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-ea1f1bb elementor-widget elementor-widget-heading" data-id="ea1f1bb" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h3 class="elementor-heading-title elementor-size-default">{{ homeContentStore.contents.ourClient.title }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c440c3b" data-id="c440c3b" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div v-for="clients in homeContentStore.contents.clients" :key="clients._id" class="elementor-element elementor-element-9e43b7b elementor-widget__width-auto elementor-widget elementor-widget-image item-client" data-id="9e43b7b" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img decoding="async" width="118" height="27" :src="clients.image" class="attachment-full size-full wp-image-2493" alt="" :data-lazy-src="clients.image" />
              <noscript><img loading="lazy" decoding="async" width="118" height="27" :src="clients.image" class="attachment-full size-full wp-image-2493" alt="" /></noscript>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import '@splidejs/vue-splide/css';
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'OurClientSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>

<style scoped>
  .elementor-1905 .elementor-element.elementor-element-9e43b7b {
    margin: 10px;
  }
  .elementor-1905 .elementor-element.elementor-element-c440c3b > .elementor-element-populated {
    /* margin: 10px; */
  }
  .elementor-1905 .elementor-element.elementor-element-c440c3b.elementor-column > .elementor-widget-wrap {
    justify-content: start;
  }
  .item-client {
    border: 1px solid #ededed;
    width: 140px !important;
    height: 156px;
    align-items: center;
    display: flex;
    justify-content: center;
  }
</style>